import React from 'react';
import PropTypes from 'prop-types';
import LiveEvents from '../components/DatesStep/LiveEvents';
import { EDITING_PRODUCTION_ENTITY_TYPES } from '../constants';

const EditPerformancesStep = ({ entity, production, step, type }) => (
  <LiveEvents production={production} editingProfile={entity} sectionStep={step} type={type} />
);

EditPerformancesStep.propTypes = {
  entity: PropTypes.object,
  production: PropTypes.object,
  step: PropTypes.number,
  type: PropTypes.oneOf(Object.values(EDITING_PRODUCTION_ENTITY_TYPES)).isRequired,
};

export default EditPerformancesStep;
